/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CategoryInputs */



/**
* | output |
* | --- |
* | "Category" |
*
* @param {Common_CategoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_category = /** @type {((inputs?: Common_CategoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CategoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Catégorie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Categoría")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Categoria")
	if (locale === "it") return /** @type {LocalizedString} */ ("Categoria")
	return /** @type {LocalizedString} */ ("Category")
});